import gql from 'graphql-tag';

export const purchasedEventTransferCreate = gql`
  mutation purchasedEventTransferCreate(
    $input: PurchasedEventTransferCreateInput!
  ) {
    purchasedEventTransferCreate(input: $input) {
      purchased_event_transfer {
        id
      }
    }
  }
`;

export const purchasedEventDelete = gql`
  mutation purchasedEventDelete($input: PurchasedEventDeleteInput!) {
    purchasedEventDelete(input: $input) {
      success
    }
  }
`;
